import { z } from "zod";

export const PersonFactNodeContentSchema = z.object({
  nodeType: z.literal("person"),
  version: z.literal("1"),

  name: z.string().max(128),
  alias: z.string().max(128).optional(),

  contact: z
    .object({
      phoneNumber: z
        .string()
        .max(128)
        .optional()
        .describe("The phone number for this person, including country code"),
      email: z.string().email().optional(),
      website: z.string().url().optional(),
      country: z.string().max(128).optional(),
      timezone: z
        .string()
        .max(128)
        .optional()
        .describe("The timezone for this person, e.g UTC+2"),
    })
    .optional(),
});

export const PersonWorksAtFactEdgeMetadataSchema = z.object({
  edgeType: z.literal("worksAt"),
  version: z.literal("1"),
  joinedAt: z
    .date()
    .optional()
    .describe("If available, the date this person joined the company"),
});

export const PersonKnowsFactEdgeMetadataSchema = z.object({
  edgeType: z.literal("knowsPerson"),
  version: z.literal("1"),

  relationship: z
    .string()
    .max(128)
    .optional()
    .describe("The type of relationship between two persons"),
});
